/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import {
  Grid,
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  Carousel,
} from "react-bootstrap";
import Card from "Admin/components/Card/Card.jsx";
import * as API from '../../../../api/emr'
import { languageList } from "../../../../api/language";
import { Right } from "react-bootstrap/lib/Media";

const AddEditRecoomendation = (props) => {
  let history = useHistory();

  const [formData, setFormData] = useState({
    recommendedLanguage: {},
    recommendedType: "top",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [alert, setAlert] = useState(null);
  const [isSpecialCharacter, setIsSpecialChar] = useState(false);
  const [mode, setMode] = useState("add");
  const [recommendationId, setRecommendationId] = useState("");
  const [languageArr, setLanguageArr] = useState([]);
  const [isRecommendationAlredyExist, setIsRecommendationExist] =
    useState(false);
  const [recommendationAlredyExistMsg, setRecommendationAlredyExistMsg] =
    useState("");

  const getLanguageList = async () => {
    let resp = await languageList({ limitStatus: true });
    if (resp.data.status === "Success" && resp.data.statusCode === 200) {
      setLanguageArr(resp.data.data.data);
    }
  };

  const inputHandler = (e, language) => {
    if (isRecommendationAlredyExist) {
      setIsRecommendationExist(false);
      setRecommendationAlredyExistMsg("");
    }
    let saveFormData = formData;

    if (e.target.name === "recommendedType")
      saveFormData[e.target.name] = e.target.value;
    else {
      let str = e.target.value.replace(/\s+/g, " ");
      saveFormData.recommendedLanguage[language] = str.trimStart();
      saveFormData[e.target.name] = str.trimStart();
    }
    setFormData({ ...formData, ...saveFormData });
    validate();
  };

  const validate = () => {
    let post = formData;
    let errArr = errors;
    let errflag = true;

    if (post.recommendedLanguage_1 && post.recommendedLanguage_1 != "") {
      errArr.recommendedLanguage_1 = "";
    } else {
      errArr.recommendedLanguage_1 = "error";
      errflag = false;
    }
    setErrors({ ...errArr });
    return errflag;
  };

  const submitHandler = async (event) => {
    setIsLoading(true);
    event.preventDefault();

    if (validate()) {
      let sentData = new FormData();
      sentData.append(
        "recommendedLanguage",
        JSON.stringify(formData.recommendedLanguage)
      );
      sentData.append("recommendedType", formData.recommendedType);
      let resp = "";
      if (mode === "add") {
        resp = await API.addRecommendation(sentData);
        if (resp.data.statusCode == 200 && resp.data.status === "Success") {
          if (resp.data.flag && resp.data.flag === "existing") {
            setIsRecommendationExist(true);
            setRecommendationAlredyExistMsg(resp.data.msg);
          } else
            history.push({
              pathname: "/admin/recommendation-list",
              from: "add",
            });
        }
      } else {
        sentData.append("recommendedId", recommendationId);
        resp = await API.updateRecommendation(sentData);
        setIsLoading(false);
        if (resp.data.statusCode == 200 && resp.data.status === "Success") {
          if (resp.data.flag && resp.data.flag === "existing") {
            setIsRecommendationExist(true);
            setRecommendationAlredyExistMsg(resp.data.msg);
          } else
            history.push({
              pathname: "/admin/recommendation-list",
              from: "edit",
            });
        }
      }
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getLanguageList();
    let row = props.location.state?.row;

    let saveFormData = formData;
    //console.log(row,"rowwwwwwwwwwwww")
    if (row !== undefined && row) {
      setMode("edit");
      setRecommendationId(row._id);
      saveFormData["recommendedLanguage"] = row.recommendedLanguage;
      saveFormData["recommendedLanguage_1"] = row.recommendedLanguage[1];
      let recommendationType = "top";
      if (row.recommendedType && row.recommendedType.length > 0) {
        row.recommendedType.map((obj, key) => {
          if (obj.top && obj.top === 1) recommendationType = "top";
          else if (obj.bottom && obj.bottom === 1)
            recommendationType = "bottom";
        });
      }
      saveFormData["recommendedType"] = recommendationType;
      setFormData({ ...formData, ...saveFormData });
    }
  }, []);
  return (
    <div className="main-content">
      <Grid fluid>
        <Row>
          <Col md={12}>

            <Card
              title={
                <Row>
                  <Col md={12} style={{ textAlign: 'Right' }}>
                    <Button
                      // className="go-back-btn-1"
                      bsStyle="info"
                      onClick={(e) => {
                        history.goBack();
                      }}
                    >
                      Back
                    </Button>
                  </Col>
                </Row>
              }
              content={
                <Form horizontal className="add-supportsystem_form">
                  <fieldset style={{ width: '100%' }}>
                    <FormGroup>
                      <Col componentClass={ControlLabel} sm={2}>
                        Recommendation <span className="star">*</span>
                      </Col>
                      <Col sm={6} className="spcc">
                        {languageArr.map(function (lang, key) {
                          return (
                            <><label>{lang.name}</label>
                              <FormControl
                                key={lang.lanId}
                                autoComplete="off"
                                type="text"
                                value={
                                  formData.recommendedLanguage[lang.lanId]
                                    ? formData.recommendedLanguage[lang.lanId]
                                    : ""
                                }
                                name={"recommendedLanguage_" + lang.lanId}
                                id={"recommendedLanguage_" + lang.lanId}
                                placeholder={lang.name}
                                onChange={(event) => {
                                  inputHandler(event, lang.lanId);
                                }}
                                className={
                                  "spc-in insulin-input " +
                                  (lang.lanId === 1
                                    ? errors.recommendedLanguage_1
                                      ? errors.recommendedLanguage_1
                                      : ""
                                    : "")
                                }
                              /></>
                          );
                        })}
                      </Col>
                    </FormGroup>
                  </fieldset>
                  <fieldset style={{ width: '100%' }}>
                    <FormGroup>
                      <Col componentClass={ControlLabel} sm={2}>
                        Type <span className="star">*</span>
                      </Col>
                      <Col sm={6} className="spcc">
                        <select
                          className="form-control"
                          name="recommendedType"
                          value={formData.recommendedType}
                          onChange={(e) => {
                            inputHandler(e);
                          }}
                        >
                          <option value="top">Top</option>
                          <option value="bottom">Bottom</option>
                        </select>
                      </Col>
                    </FormGroup>
                  </fieldset>

                  <div className="col-sm-10">
                    <legend className="line-removes" style={{ textAlign: 'center', fontSize: '18px' }}>
                      {isRecommendationAlredyExist &&
                        <span className="star">{recommendationAlredyExistMsg}</span>
                      }
                    </legend>
                  </div>

                  <fieldset style={{ width: '100%' }}>
                    <FormGroup>
                      <ControlLabel className="col-sm-2"></ControlLabel>
                      <Col sm={12} className="btn_wrap">
                        <Col md={12}>
                          <button
                            type="button"
                            className="btn-fill btn-wd btn btn-primary"
                            onClick={(e) => {
                              submitHandler(e);
                            }}
                            disabled={isLoading}
                          >
                            {isLoading && <span class="fa fa-spinner fa-spin spinner-btn"></span>}
                            Submit
                          </button>
                          &nbsp;
                        </Col>
                      </Col>
                    </FormGroup>
                  </fieldset>
                </Form>
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default AddEditRecoomendation;
